(ns rothko.nav.component
  (:require [clojure.spec.alpha :as s]
            [rothko.component.core :refer [defcomp]]
            [rothko.css.inline :refer [declarations->class cond-declarations->class]]
            [rothko.icon.component :as icon]
            [rothko.link.styles :as link-styles]
            [taoensso.timbre :as log]))

(defcomp nav-item
  {:component-type ::nav-item}
  [{:keys [appearance
           disabled?
           icon
           key
           menu-toggle-handler
           on-click
           route
           route-handler
           selected?
           selected-fn
           theme
           title]
    :as props}]
  (let [selected? (or selected? (selected-fn props route))
        item-icon (when icon
                    [icon/icon {:icon icon
                                :size 24
                                :class appearance}])
        item-title [:span title]]
    [:li
     (if (or disabled? selected?)
       [:span.nav__item
        {:class (cond-> appearance
                  disabled? (conj :disabled)
                  selected? (conj :selected))}
        item-icon item-title]
       [:a.nav__item
        (cond-> {:class appearance
                 :href (when route (route-handler route))
                 :on-click #(do (when on-click (on-click))
                                (menu-toggle-handler key %))}
          disabled? (assoc :disabled true))
        item-icon item-title])]))

(defcomp footer-item
  {:component-type ::footer-item}
  [{:keys [appearance mail-to on-click route route-handler theme title]
    :or {on-click :noop}
    :as props}]
  [:li.nav__footer-item {:class appearance}
   [:a {:href (cond
                route
                (route-handler route)

                mail-to
                (str "mailto:" mail-to)

                :otherwise
                (log/error "Unable to calculate href" props))
        :on-click on-click}
    title]])

(defcomp nav
  "Uses routes param on each item to determine if the current route is selected.
  If more than one route is supplied the nav item will be passed the first route in the collection"
  {:component-type ::nav}
  [{:keys [appearance
           current-route
           footer-items
           items
           menu-toggle-handler
           route-handler
           selected-fn
           theme]
    :or {selected-fn (fn [{:keys [current-route]} item-route]
                       (= (first item-route) (:handler current-route)))}
    :as props}]
  [:nav {:class appearance}
   [:ul.nav__items {:class appearance}
    (for [item items :when item]
      [nav-item (merge props {:selected-fn selected-fn} item)])]
   (when footer-items
     [:ul.nav__footer {:class appearance}
      (for [{:keys [routes] :as item} footer-items]
        [footer-item (merge {:on-click menu-toggle-handler
                             :route (first routes)
                             :route-handler route-handler}
                            item)])])])
